import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";
import { shallow } from "zustand/shallow";
import Breadcrumb from "../../components/Breadcrumb";
import Search from "../../components/form/Search";
import MobileListActionBar from "../../components/mobile-action-bar/MobileListActionBar";
import Pagination from "../../components/Pagination";
import useResponsiveLimit from "../../composables/useResponsiveLimit";
import { useItemStore } from "../../stores/items";

function Item({ item }) {
  const { t } = useTranslation();

  return (
    <tr>
      <td>
        <Link to={`${item.id}/edit`} className="fw-bold">
          {item.number}
        </Link>
      </td>
      <td>
        {/*<Link
          to={`${item.id}/details`}
          className="text-dark text-decoration-none"
        >
          {item.name}
        </Link>*/}
        {item.name}
      </td>
      <td>
        <ul className="list-group list-unstyled">
          {(item.groups || []).map((group) => (
            <li key={group.id}>{group.name}</li>
          ))}
        </ul>
      </td>
      <td className="text-center">{item.highlight && <i className="fa fa-check" />}</td>
      <td className="text-center">{t(`items.characteristics.short.${item.characteristic}`)}</td>
      <td className="text-center">{item.inspect_every_x_months}</td>
      <td className="text-nowrap">{item.created_by?.name}</td>
      <td className="text-nowrap">{item.updated_by?.name}</td>
    </tr>
  );
}

function Items() {
  const { t } = useTranslation();
  const [queryParams, setQueryhParams] = useSearchParams();

  const [byIds, allIds, total, fetchSome] = useItemStore(
    (state) => [state.byIds, state.allIds, state.total, state.fetchSome],
    shallow,
  );

  const items = allIds.map((id) => byIds[id]);

  const search = queryParams.get("q") || "";
  const defaultLimit = useResponsiveLimit(10);
  const limit = parseInt(queryParams.get("limit")) || defaultLimit;
  const page = parseInt(queryParams.get("page")) || 0;
  const offset = page * limit;
  const sortBy = queryParams.get("sort_by") || "number";
  const sortDir = queryParams.get("sort_dir") || "asc";

  useEffect(() => {
    fetchSome({ q: search, limit, offset, sort_by: sortBy, sort_dir: sortDir });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, page, limit, sortBy, sortDir]);

  const handleSearch = (e) => {
    setQueryhParams(`page=0&q=${e.target.value}&sort_by=${sortBy}&sort_dir=${sortDir}`);
  };

  const handleSort = (column) => {
    const newDir = sortBy === column && sortDir === "asc" ? "desc" : "asc";
    setQueryhParams(`page=0&q=${search}&sort_by=${column}&sort_dir=${newDir}`);
  };

  return (
    <div>
      <Breadcrumb items={[{ label: t("items.items") }]}>
        <Link to="/items/add" className="btn btn-red">
          <i className="fa fa-plus fa-lg me-2 ms-n2"></i> {t("menu.add")}
        </Link>
      </Breadcrumb>

      <MobileListActionBar>
        <Link to="/items/add" className="btn btn-red flex-fill">
          <i className="fa fa-plus fa-fw me-1" />
          {t("menu.add")}
        </Link>
      </MobileListActionBar>

      {/*<div className="mb-3 mx-3 mx-md-0 d-sm-flex fw-bold">
        <div className="mt-sm-0 mt-2">
          <a href="#/" className="text-dark text-decoration-none">
            <i className="fa fa-download fa-fw me-1 text-dark text-opacity-50"></i>{" "}
            {t("menu.export")}
          </a>
        </div>
        <div className="ms-sm-4 ps-sm-1 mt-sm-0 mt-2">
          <a href="#/" className="text-dark text-decoration-none">
            <i className="fa fa-upload fa-fw me-1 text-dark text-opacity-50"></i>{" "}
            {t("menu.import")}
          </a>
        </div>
        <div className="ms-sm-4 ps-sm-1 mt-sm-0 mt-2 dropdown-toggle">
          <a
            href="#/"
            data-bs-toggle="dropdown"
            className="text-dark text-decoration-none"
          >
            <i className="fa fa-cog fa-fw me-1 text-dark text-opacity-50"></i>{" "}
            {t("menu.more")} <b className="caret"></b>
          </a>
          <div className="dropdown-menu">
            <a className="dropdown-item" href="#/">
              Action
            </a>
            <a className="dropdown-item" href="#/">
              Another action
            </a>
            <a className="dropdown-item" href="#/">
              Something else here
            </a>
            <div role="separator" className="dropdown-divider"></div>
            <a className="dropdown-item" href="#/">
              Separated link
            </a>
          </div>
        </div>
      </div>
      */}

      <div className="card border-0">
        <ul className="nav nav-tabs nav-tabs-v2 px-3">
          <li className="nav-item me-2">
            <a href="#allTab" className="nav-link active px-2" data-bs-toggle="tab">
              {t("menu.all")}
            </a>
          </li>
          <li className="nav-item me-2">
            <a href="#deletedTab" className="nav-link px-2" data-bs-toggle="tab">
              {t("menu.deleted")}
            </a>
          </li>
        </ul>
        <div className="tab-content p-3">
          <div className="tab-pane fade show active" id="allTab">
            <Search handleSearch={handleSearch} search={search} />

            <div className="table-responsive mb-3">
              <table className="table table-hover table-panel text-nowrap align-middle mb-0">
                <thead>
                  <tr>
                    <th
                      width={1}
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleSort("number")}
                    >
                      {t("common.number_short")}
                      {sortBy === "number" && <i className={`fa fa-sort-${sortDir === "asc" ? "up" : "down"} ms-1`} />}
                    </th>
                    <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleSort("name")}>
                      {t("items.items")}
                      {sortBy === "name" && <i className={`fa fa-sort-${sortDir === "asc" ? "up" : "down"} ms-1`} />}
                    </th>
                    <th>{t("items.groups.group")}</th>
                    <th
                      width={1}
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleSort("highlight")}
                    >
                      {t("items.highlight_short")}
                      {sortBy === "highlight" && (
                        <i className={`fa fa-sort-${sortDir === "asc" ? "up" : "down"} ms-1`} />
                      )}
                    </th>
                    <th
                      width={1}
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleSort("characteristic")}
                    >
                      {t("items.characteristics.characteristic")}
                      {sortBy === "characteristic" && (
                        <i className={`fa fa-sort-${sortDir === "asc" ? "up" : "down"} ms-1`} />
                      )}
                    </th>
                    <th
                      width={1}
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleSort("inspect_every_x_months")}
                    >
                      {t("items.inspect_every_x_months")}
                      {sortBy === "inspect_every_x_months" && (
                        <i className={`fa fa-sort-${sortDir === "asc" ? "up" : "down"} ms-1`} />
                      )}
                    </th>
                    <th
                      width={1}
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleSort("created_by")}
                    >
                      {t("common.created_by")}
                      {sortBy === "created_by" && (
                        <i className={`fa fa-sort-${sortDir === "asc" ? "up" : "down"} ms-1`} />
                      )}
                    </th>
                    <th
                      width={1}
                      style={{ cursor: "pointer", userSelect: "none" }}
                      onClick={() => handleSort("updated_by")}
                    >
                      {t("common.updated_by")}
                      {sortBy === "updated_by" && (
                        <i className={`fa fa-sort-${sortDir === "asc" ? "up" : "down"} ms-1`} />
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item) => (
                    <Item key={item.id} item={item} />
                  ))}
                </tbody>
              </table>
            </div>

            <Pagination
              basePath="/items"
              page={page}
              limit={limit}
              total={total}
              queryParams={queryParams}
              label={t("items.items")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Items;
